<audio #audioPlayerDing>
  <source src="assets/audio/ding.mp3" type="audio/mp3" />
</audio>

<audio #audioPlayerDong>
  <source src="assets/audio/dong.mp3" type="audio/mp3" />
</audio>

<div #grid class="grid">
  <div cdkDropListGroup>
    @for (monitorGroupColumn of monitorLayout?.MonitorColumns; track monitorGroupColumn) {
      <div class='monitor-group-column' cdkDropList [cdkDropListData]="monitorGroupColumn.MonitorGroups" (cdkDropListDropped)="drop($event)">
        <div class="grid-item" [ngStyle]="{'width': tileWidth + 'px'}"></div>
        @for (monitorGroup of monitorGroupColumn.MonitorGroups; track monitorGroup) {
          <div class="grid-item" [ngStyle]="{'width': tileWidth + 'px'}" (cdkDragStarted)="dragStart($event)" cdkDrag>
            <div class="panel panel-info">
              <div (click)="clickMonitorGroupHeader(monitorGroup)" [ngClass]="{'panel-heading': true, 'monitor-group-panel-heading-ok': monitorGroup.Status=='Ok', 'monitor-group-panel-heading-error': monitorGroup.Status=='Error', 'monitor-group-panel-heading-warning': monitorGroup.Status=='Warning', 'monitor-group-panel-heading-none': monitorGroup.Status=='None'}">
                <div class="horizontal-align">
                  <h3 class="panel-title monitor-panel-title">{{monitorGroup.Name}}</h3>
                  @if (hasPausedChild(monitorGroup)) {
                    <div class="monitor-item-indicator-pause-header">
                      <app-status-traffic-light [status]="'Pause'" [tooltip]="'Contains paused elements'"></app-status-traffic-light>
                    </div>
                  }
                </div>
              </div>
              @if (monitorGroup.ShowType == 1 || monitorGroup.ShowType == 2 && (monitorGroup.Status=='Warning' || monitorGroup.Status=='Error') || monitorGroup.ShowType == 3 && monitorGroup.Status=='Error') {
                <ul class="list-group">
                  @for (monitorItem of monitorGroup?.MonitorItems; track monitorItem) {
                    @if (monitorGroup.ShowType == 1 || monitorGroup.ShowType == 2 && (monitorItem.LatestStatus=='Warning' || monitorItem.LatestStatus=='Error') || monitorGroup.ShowType == 3 && monitorItem.LatestStatus=='Error') {
                      <li class="monitor-list-item list-group-item" (click)="clickMonitorItem(monitorItem)">
                        @if (monitorItem.AbsenceItemTemplate !== null) {
                          <div class="monitor-item-indicator-pause">
                            <app-status-traffic-light [status]="'Pause'" [tooltip]="$safeNavigationMigration(monitorItem.AbsenceItemTemplate?.Note)"></app-status-traffic-light>
                          </div>
                        }
                        <div class="monitor-item-indicator">
                          <app-status-traffic-light [status]="monitorItem.LatestStatus"></app-status-traffic-light>
                        </div>
                        <span class="monitor-item-header">{{monitorItem.Name}}</span>
                        <br />
                        @if (monitorItem.LatestStatusTime != null) {
                          <span
                          class="monitor-item-subheading">{{dateTimeService.getDevExpressDateTimeFunction(monitorItem.LatestStatusTime)}}</span>
                        }
                        @if (monitorItem.LatestStatusTime == null) {
                          <span
                          class="monitor-item-subheading">No status available</span>
                        }
                      </li>
                    }
                  }
                </ul>
              }
            </div>
          </div>
        }
        @if (monitorGroupColumn.length === 0) {
          <div [ngStyle]="{'width': tileWidth + 'px'}"></div>
        }
      </div>
    }
  </div>
</div>
